class ProductForm extends HTMLElement {
constructor() {
super();
this.form = this.querySelector('form');
this.variantIdInput.disabled = false;
this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
this.cartNotification = document.querySelector('cart-notification');
this.cartItems = document.querySelector('cart-items');
this.cartMain = document.querySelector('cart-main');
this.cartFooter = document.getElementById('cart-footer');
this.siteHeader = document.querySelector('.section--site-header');
this.cartDrawer = document.getElementById('cart-drawer');
this.cartDrawerOpener = document.getElementById('cart-drawer-opener');
this.submitButton = this.querySelector('[type="submit"]');
this.submitButtonText = this.submitButton.querySelector('span');
this.hideErrors = this.dataset.hideErrors === 'true';
}
onSubmitHandler(event) {
event.preventDefault();
if (this.submitButton.classList.contains('loading')) return;
this.handleErrorMessage();
this.submitButton.setAttribute('aria-disabled', true);
this.submitButton.classList.add('loading');
const config = fetchConfig('javascript');
config.headers['X-Requested-With'] = 'XMLHttpRequest';
delete config.headers['Content-Type'];
const formData = new FormData(this.form);
if (themeSettings.template_name === 'cart') {
formData.append('sections', this.cartMain.getSectionsToRender().map((section) => section.id));
formData.append('sections_url', window.location.pathname);
config.body = formData;
} else if (themeSettings.cart_type === 'page') {
formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
formData.append('sections_url', window.location.pathname);
config.body = formData;
} else {
if (this.cartDrawer) {
formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.id));
formData.append('sections_url', window.location.pathname);
config.body = formData;
} else if (Shopify.designMode) {
alert('The cart drawer needs to be enabled in the theme editor for products to be able to be added to the cart. Check the "Header group" to make sure that the section is enabled.');
return;
} else {
console.error('Cart drawer not found. Make sure that the section is enabled in the Shopify theme editor.');
return;
}
}
fetch(`${routes.cart_add_url}`, config)
.then((response) => response.json())
.then((response) => {
if (response.status) {
publish(PUB_SUB_EVENTS.cartError, {
source: 'product-form',
productVariantId: formData.get('id'),
errors: response.errors || response.description,
message: response.message,
});
this.handleErrorMessage(response.description);
const soldOutMessage = this.submitButton.querySelector('.js-sold-out-message');
if (!soldOutMessage) return;
this.submitButton.setAttribute('aria-disabled', true);
this.submitButtonText.classList.add('display--hidden');
soldOutMessage.classList.remove('display--hidden');
this.error = true;
return;
}
document.querySelectorAll('simple-modal-dialog').forEach((dialog) => {
dialog.hide();
});
const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
if (!this.error) {
publish(PUB_SUB_EVENTS.cartUpdate, {
source: 'product-form',
productVariantId: formData.get('id'),
cartData: response,
}).then(() => {
CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
});
if (themeSettings.template_name === 'cart') {
this.cartItems.querySelector('#cart-items-loader').classList.add('display--hidden');
this.cartMain.getSectionsToRender().forEach((section => {
document.getElementById(section.id).innerHTML =
this.getSectionInnerHTML(response.sections[section.id], section.selector);
}));
this.cartItems.hideEmptyCart();
window.scrollTo({top: 0, behavior: 'smooth'});
} else if (themeSettings.cart_type === 'page') {
this.cartNotification.setActiveElement(document.activeElement);
this.cartNotification.renderContents(response);
this.cartNotification.open();
} else {
this.cartItems.querySelector('#cart-items-loader').classList.remove('display--hidden');
this.cartDrawerOpener.openDrawer('cart-drawer');
this.cartDrawer.setActiveElement(document.activeElement);
this.cartItems.querySelector('#cart-items-loader').classList.add('display--hidden');
this.cartDrawer.getSectionsToRender().forEach((section => {
document.getElementById(section.id).innerHTML =
this.getSectionInnerHTML(response.sections[section.id], section.selector);
}));
this.cartItems.hideEmptyCart();
trapFocus(this.cartDrawer);
}
}
this.error = false;
})
.catch((e) => {
console.error(e);
if (!this.cartItems) return;
this.cartItems.querySelector('#cart-items-loader').classList.remove('display--hidden');
})
.finally(() => {
this.submitButton.classList.remove('loading');
this.submitButton.removeAttribute('aria-disabled');
CartPerformance.measureFromEvent("add:user-action", event);
});
}
handleErrorMessage(errorMessage = false) {
if (this.hideErrors) return;
this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('[data-error-message-wrapper]');
this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('[data-error-message]');
this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
if (errorMessage) {
this.errorMessage.textContent = errorMessage;
}
}
toggleSubmitButton(disable = true, text) {
if (disable) {
this.submitButton.setAttribute('disabled', 'disabled');
if (text) this.submitButtonText.textContent = text;
} else {
this.submitButton.removeAttribute('disabled');
this.submitButtonText.textContent = window.variantStrings.addToCart;
}
}
getSectionInnerHTML(html, selector = '.shopify-section') {
return new DOMParser()
.parseFromString(html, 'text/html')
.querySelector(selector).innerHTML;
}
get variantIdInput() {
return this.form.querySelector('[name=id]');
}
}
customElements.define('product-form', ProductForm);